import requestLogin from '@/utils/requestLogin.js'

// 发送短信 /v1/sms/send
function getSmsSend(data) {
    return requestLogin({
        url: '/v1/sms/send',
        method: 'get',
        params:data
    })
}



export default {
    getSmsSend
}
